import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight, X } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { mediaUrl } from "@/context/SettingsContext";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RecruitGallery = () => {
  const { t } = useLanguage();
  const r = t.recruit;
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { axios.get(`${API}/gallery`).then((res) => setItems(res.data.filter((i) => i.category === "formation").slice(0, 8))).catch(() => {}); }, []);
  if (items.length === 0) return null;

  return (
    <section className="py-20" data-testid="recruit-gallery">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <SectionHead overline={r.galleryOverline} title={r.galleryTitle} accent={r.galleryAccent} sub={r.gallerySub} />
          <Reveal delay={0.2}>
            <Link to="/galerie" data-testid="recruit-gallery-all" className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-gold hover:text-gold-hover">{r.galleryAll}<ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></Link>
          </Reveal>
        </div>
        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
          {items.map((it, i) => (
            <Reveal key={it.id} delay={0.06 * i}>
              <button type="button" onClick={() => setOpen(it)} data-testid={`recruit-gallery-item-${i}`} className="group relative block h-full w-full overflow-hidden rounded-3xl bg-mint">
                <img src={mediaUrl(it.url)} alt={it.caption || ""} loading="lazy" className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                {it.caption && <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-forest/80 to-transparent p-4 text-left text-xs text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">{it.caption}</span>}
              </button>
            </Reveal>
          ))}
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-forest/90 p-4" onClick={() => setOpen(null)} data-testid="recruit-gallery-lightbox">
          <button className="absolute right-5 top-5 rounded-full bg-white/10 p-3 text-white hover:bg-white/20" data-testid="recruit-gallery-close"><X className="h-5 w-5" /></button>
          <img src={mediaUrl(open.url)} alt={open.caption || ""} className="max-h-[85vh] max-w-full rounded-2xl object-contain shadow-2xl" />
          {open.caption && <p className="absolute bottom-6 left-1/2 -translate-x-1/2 rounded-full bg-white/10 px-4 py-2 text-sm text-white">{open.caption}</p>}
        </div>
      )}
    </section>
  );
};

export default RecruitGallery;
